<template>
    <div class="main-mobile-header">
        <div class="mobile-header">
            <div class="container-logo">
                <img :src="require('@/assets/img/university-logo-small.svg') " alt="uni logo" />
            </div>
            
            <slot name="testStudentMobile"></slot>

            <div class="container-button">
                <img v-if="!menu1" @click=" menu1 = true" :src="require('@/assets/SideMenuIcons/menumenu-logo.svg') " alt="menu logo" />
                <svg v-else @click="menu1 = false"  class="icon-close-mobile" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M6 5L18.7279 17.7279" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
                    <path d="M6 18L18.7279 5.27208" stroke="#ffffff" stroke-width="2" stroke-linecap="round"/>
                </svg>
            </div>
        </div>
        <div v-if="menu1" class="menu-mobile" :class="{ 'side-menu-student': userRoles === 'Student'}">
            <div class="side-menu__header-mobile">
                <img class="img-logo-menu-mobile" :src=" require('@/assets/img/university-logo.svg')" alt="uni logo" />
            </div>

            <!-- Icon + text -->
            <div class="side-menu__opened-content-mobile">
                <div class="side-menu__student-ava-mobile">
                    <img class="side-menu__student-image-mobile" :src="userInfo.logoUrl ? apiImg + userInfo.logoUrl : ''">
                </div>
                <p class="side-menu__student-name-mobile" >{{`${userInfo.fname} ${userInfo.iname} ${userInfo.oname}`}}</p>

                <ul v-if="!testStudent" class="side-menu__nav-bar-mobile">
                    <p class="side-menu__name">МЕНЮ</p>
                    <li
                        v-for="(item, key) in calculateAccess" :key="key"
                        class="side-menu__nav-item-mobile"
                        :class="{'active_nav': $route.name == item.path}"
                        @click.prevent="$router.push({ name: item.path }); menu1 = false;"
                    >
                        <inline-svg style="margin-left: 20px;" :src="require(`../../assets/SideMenuIcons/${item.icon}.svg`)" />

                        <p>{{ item.text }}</p>
                    </li>
                    <li @click="dialog = true" class="side-menu__nav-item-mobile">
                        <inline-svg style="margin-left: 20px;" :src="require(`../../assets/SideMenuIcons/Logout.svg`)" />
                        <p>Выход</p>
                    </li>
                </ul>



                <ul v-if="testStudent" class="side-menu__nav-bar-mobile">
                    <p class="side-menu__name">Ваши действия</p>
                    <li
                        v-for="(item, index) in actions"
                        :key="'F'+index"
                        class="side-menu__nav-item-mobile"
                        v-show="item.view"
                    >
                        <inline-svg v-if="item.success" class="ml-4" :src="require(`@/assets/img/icons/SuccessStep.svg`)" />
                        <p>{{ item.name }}</p>
                    </li>

                    <li class="side-menu__nav-item-mobile" @click="dialogEndTest = true">
                        <inline-svg class="ml-4" :src="require(`../../assets/SideMenuIcons/Logout.svg`)" />
                        <p>Завершить тест</p>
                    </li>
                </ul>
            </div>

            <v-dialog v-model="dialog" max-width="410" persistent>
                <v-card>
                    <v-card-title class="text-h6" style="word-break: normal;">
                        Вы уверены, что хотите выйти?
                    </v-card-title>

                    <v-card-actions class="d-flex justify-center">
                        <v-btn text @click="dialog = false" class="mr-2 act">Нет</v-btn>
                        <v-btn class="act" text @click="logoutSystem()">Да</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

            <v-dialog v-model="dialogEndTest" max-width="690" persistent >
                <v-card>
                    <v-card-title class="text-h5" style="word-break: normal;">
                        Вы уверены, что хотите завершить прохождение теста?
                    </v-card-title>

                    <v-card-actions class="d-flex justify-center">
                        <v-btn text @click="dialogEndTest = false" class="mr-2 act">Нет</v-btn>
                        <v-btn class="act" text @click="$router.replace('/lkstudents/tests')">Да</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>

        </div>

        <div v-if="$route.name == 'Human'" class="metodist-side-bar" :class="{ 'opened': sideMenuOpened, 'closed': !sideMenuOpened }">
            <MetodistSideBar :mobile="mobile" @toggleMenu="toggleMenu()" />
        </div>
    </div>
</template>
<script>
import "./index.scss";
import { mapGetters, mapActions, mapMutations } from "vuex";
import inlineSvg from 'vue-inline-svg'

export default {
    name: "Patients",
    components:{
        inlineSvg,
    },
	 props: {
		testStudentMobile: Boolean,
        testStudent: Boolean,
        actions: Array
	},
    data(){
        return{
            menu1: false,
            sideMenuOpened: false,
			dialog: false,
			dialogEndTest: false,
			menu: [
				{ text: 'Профиль', path: 'Profile', icon: 'Profile', roles: [{ role: 'Teacher', view: true}, { role: 'Metodist', view: false}, { role: 'Student', view: false}] },
				{ text: 'Обучение', path: 'training', icon: 'AcademicCap', roles: [{ role: 'Student', view: true}] },
				{ text: 'Тестирование', path: 'tests', icon: 'List', roles: [{ role: 'Student', view: true}] },
				{ text: 'Задания', path: 'tasks', icon: 'Task', roles: [{ role: 'Teacher', view: true}] },
				{ text: 'Студенты', path: 'students', icon: 'AcademicCap', roles: [{ role: 'Teacher', view: true}] },
				{ text: 'Оценка знаний', path: 'Assessment', icon: 'AssessmentOfKnowledge', roles: [{ role: 'Teacher', view: true}, { role: 'Student', view: true}] },
				{ text: 'Знания', path: 'Knowledge', icon: 'AcademicCap', roles: [{ role: 'Metodist', view: true }] },
				{ text: 'Медиахранилище', path: 'MediaStorage', icon: 'MediaStorage', roles: [{ role: 'Metodist', view: true}] },
				{ text: 'Пациенты', path: '', icon: 'Patients', roles: [{ role: 'Metodist', view: true}] },
				{ text: 'Тесты', path: 'TestTasks', icon: 'List', roles: [{ role: 'Metodist', view: true}] },
				{ text: 'Справочники', path: 'Directory', icon: 'Book', roles: [{ role: 'Metodist', view: true}] },
			]
        }
    },
    computed:{
        ...mapGetters({
			apiImg: "apiImg",
			userRoles: "login/userRoles",
			userInfo: "user/userInfo",
			apiUrl: 'apiUrl',
			getShowContainers: 'takeDiagnosticTest/getShowContainers',
		}),
        calculateAccess() {
			let res = [];
			for (let i = 0; i < this.menu.length; i++) {
				for (let j = 0; j < this.menu[i].roles.length; j++) {
					if(this.menu[i].roles[j].role === this.userRoles && this.menu[i].roles[j].view) {
						res.push(this.menu[i])
					}
				}
			}
			return res
		}
    },
    mounted() {
		this.getUserInfo();
	},
    methods: {
		...mapActions({
			getUserInfo: "user/getUserInfo",
			logout: "login/logout"
		}),
		...mapMutations({
			setSideMenu: 'setSideMenu'
		}),
		toggleMenu() {
			this.$emit('toggleMenu');
		},
        logoutSystem() {
            this.logout()
                .then(() => {
                    this.$router.replace('/');
                })
        }
	},
    created(){

    }
};
</script>
